import { useEffect, useState } from "react";

const navItems = [
  { id: "synopsis", label: "作品简介" },
  { id: "versions", label: "版本一览" },
  { id: "characters", label: "人物角色" },
  { id: "episodes", label: "分集看点" },
  { id: "gallery", label: "精彩剧照" },
  { id: "guide", label: "观看指南" },
  { id: "reviews", label: "观众口碑" },
  { id: "faq", label: "常见问题" },
];

export default function SiteNav() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || menuOpen;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        solid ? "bg-background-50/95 backdrop-blur border-b border-background-200" : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8 h-16 md:h-20 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2 cursor-pointer">
          <span
            className={`w-9 h-9 rounded-lg flex items-center justify-center ${
              solid ? "bg-primary-500 text-background-50" : "bg-background-50/20 text-background-50"
            }`}
          >
            <i className="ri-home-heart-line text-xl"></i>
          </span>
          <span
            className={`font-heading text-lg font-semibold tracking-wide ${
              solid ? "text-foreground-950" : "text-background-50"
            }`}
          >
            漂亮的保姆
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-1">
          {navItems.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              className={`px-3 py-2 text-sm rounded-md cursor-pointer transition-colors ${
                solid
                  ? "text-foreground-700 hover:text-primary-600 hover:bg-background-100"
                  : "text-background-50/90 hover:text-background-50 hover:bg-background-50/10"
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#versions"
            className="hidden md:inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium px-4 py-2 rounded-md whitespace-nowrap cursor-pointer transition-colors"
          >
            <i className="ri-play-circle-line text-base"></i>
            立即观看
          </a>
          <button
            type="button"
            aria-label="打开导航菜单"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((v) => !v)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer ${
              solid ? "text-foreground-950" : "text-background-50"
            }`}
          >
            <i className={menuOpen ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <nav className="lg:hidden border-t border-background-200 bg-background-50 px-4 py-3 grid grid-cols-2 gap-2">
          {navItems.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              onClick={() => setMenuOpen(false)}
              className="px-3 py-2 text-sm text-foreground-700 rounded-md hover:bg-background-100 cursor-pointer"
            >
              {item.label}
            </a>
          ))}
        </nav>
      )}
    </header>
  );
}